import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useTheme } from '../contexts/ThemeContext';

const MainHeader: React.FC = () => {
    const { darkMode, setDarkMode } = useTheme();
    const [isSearchActive, setIsSearchActive] = useState(false);

    useEffect(() => {
        // Sidebar initialization
        openSidebar();
        window.addEventListener('resize', openSidebar);

        return () => {
            window.removeEventListener('resize', openSidebar);
        };
    }, []);

    const toggleSidebar = () => {
        const windowWidth = window.innerWidth;
        const body = document.body;

        if (windowWidth >= 992) {
            if (body.classList.contains("sidebar-close")) {
                body.classList.remove("sidebar-close");
                body.classList.add("sidebar-open");
            } else {
                body.classList.remove("sidebar-open");
                body.classList.add("sidebar-close");
            }
        } else {
            if (body.classList.contains("sidebar-close")) {
                body.classList.remove("sidebar-close");
                body.classList.add("sidebar-open");
            } else {
                body.classList.remove("sidebar-open");
                body.classList.add("sidebar-close");
            }
        }
    };

    const openSidebar = () => {
        const windowWidth = window.innerWidth;
        const body = document.body;
        if (windowWidth >= 992) {
            body.classList.add("sidebar-open");
            body.classList.remove("sidebar-close");
        } else {
            body.classList.add("sidebar-close");
            body.classList.remove("sidebar-open");
        }
    };

    const toggleDarkMode = () => {
        setDarkMode(!darkMode);
    };

    const toggleSearch = () => {
        setIsSearchActive(!isSearchActive);
    };

    return (
        <>
            {/* Fixed navbar */}
            <nav className="navbar navbar-expand-lg fixed-top">
                <div className="container-fluid">
                    {/* main sidebar toggle */}
                    <button className="btn btn-link btn-square sidebar-toggler" type="button" onClick={toggleSidebar}>
                        <i className="sidebar-svg bi bi-list"></i>
                    </button>

                    {/* logo */}
                    <Link className="navbar-brand" to="/app/dashboard">
                        <img data-bs-img="light" src={asset('/assets/img/logo.png')} alt="" />
                        <img data-bs-img="dark" src={asset('/assets/img/logo.png')} alt="" />
                        <div className="lh-20">
                            <span className="h4">Dev<span className="fw-bold">UIUX</span></span>
                            <p className="company-tagline">Developer Dashboard</p>
                        </div>
                    </Link>

                    {/* business selection */}
                    <div className="px-3 d-none d-md-flex">
                        <div className="input-group input-group-md rounded">
                            <span className="input-group-text">
                                <i className="bi bi-briefcase"></i>
                            </span>
                            <select className="form-select" aria-label="Default select example">
                                <option value={"all"}>All</option>
                                <option value="business">Business</option>
                                <option value="personal">Personal</option>
                                <option value="family">Family</option>
                            </select>
                        </div>
                    </div>

                    {/* search */}
                    <div className="justify-content-center d-none d-lg-flex">
                        <div className="input-group input-group-md rounded search-wrap width-240 mx-auto">
                            <span className="input-group-text">
                                <i className="bi bi-search"></i>
                            </span>
                            <input className="form-control" type="search" placeholder="Search here..." id="searchglobal" />
                            <div className="dropdown input-group-text py-0 px-1">
                                <button className="dropdown-toggle btn btn-sm btn-link btn-square no-caret" type="button" id="searchfilter" data-bs-toggle="dropdown" aria-expanded="false">
                                    <i className="bi bi-sliders fs-6"></i>
                                </button>
                                <div className="dropdown-menu dropdown-menu-end dropdown-dontclose width-300" >
                                    <ul className="nav nav-pills nav-fill" id="searchtab" role="tablist">
                                        <li className="nav-item" role="presentation"><button className="nav-link active" id="searchall-tab" data-bs-toggle="tab" data-bs-target="#searchall" type="button" role="tab" aria-controls="searchall" aria-selected="true">All</button></li>
                                        <li className="nav-item" role="presentation"><button className="nav-link" id="searchorders-tab" data-bs-toggle="tab" data-bs-target="#searchorders" type="button" role="tab" aria-controls="searchorders" aria-selected="false" >Orders</button></li>
                                        <li className="nav-item" role="presentation"><button className="nav-link" id="searchcontacts-tab" data-bs-toggle="tab" data-bs-target="#searchcontacts" type="button" role="tab" aria-controls="searchcontacts" aria-selected="false" >Contacts</button></li>
                                    </ul>
                                    <div className="tab-content py-3" id="searchtabContent">
                                        <div className="tab-pane fade active show" id="searchall" role="tabpanel">
                                            <ul className="list-group adminuiux-list-group list-group-flush bg-none show">
                                                <li className="list-group-item">
                                                    <div className="row gx-3 gx-lg-4">
                                                        <div className="col">Search apps</div>
                                                        <div className="col-auto">
                                                            <div className="form-check form-switch"><input className="form-check-input" type="checkbox" role="switch" id="isearchswitch1" /> <label className="form-check-label" htmlFor="isearchswitch1"></label></div>
                                                        </div>
                                                    </div>
                                                </li>
                                                <li className="list-group-item">
                                                    <div className="row gx-3 gx-lg-4">
                                                        <div className="col">Include Pages</div>
                                                        <div className="col-auto">
                                                            <div className="form-check form-switch"><input className="form-check-input" type="checkbox" role="switch" id="isearchswitch2" defaultChecked /> <label className="form-check-label" htmlFor="isearchswitch2"></label></div>
                                                        </div>
                                                    </div>
                                                </li>
                                                <li className="list-group-item">
                                                    <div className="row gx-3 gx-lg-4">
                                                        <div className="col">Internet resource</div>
                                                        <div className="col-auto">
                                                            <div className="form-check form-switch"><input className="form-check-input" type="checkbox" role="switch" id="isearchswitch3" /> <label className="form-check-label" htmlFor="isearchswitch3"></label></div>
                                                        </div>
                                                    </div>
                                                </li>
                                                <li className="list-group-item">
                                                    <div className="row gx-3 gx-lg-4">
                                                        <div className="col">News and Blogs</div>
                                                        <div className="col-auto">
                                                            <div className="form-check form-switch"><input className="form-check-input" type="checkbox" role="switch" id="isearchswitch4" /> <label className="form-check-label" htmlFor="isearchswitch4"></label></div>
                                                        </div>
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>
                                        <div className="tab-pane fade" id="searchorders" role="tabpanel">
                                            <ul className="list-group adminuiux-list-group list-group-flush bg-none show">
                                                <li className="list-group-item">
                                                    <div className="row gx-3 gx-lg-4">
                                                        <div className="col">Show order ID</div>
                                                        <div className="col-auto">
                                                            <div className="form-check form-switch"><input className="form-check-input" type="checkbox" role="switch" id="isearchswitch5" /> <label className="form-check-label" htmlFor="isearchswitch5"></label></div>
                                                        </div>
                                                    </div>
                                                </li>
                                                <li className="list-group-item">
                                                    <div className="row gx-3 gx-lg-4">
                                                        <div className="col">International Order</div>
                                                        <div className="col-auto">
                                                            <div className="form-check form-switch"><input className="form-check-input" type="checkbox" role="switch" id="isearchswitch6" defaultChecked /> <label className="form-check-label" htmlFor="isearchswitch6"></label></div>
                                                        </div>
                                                    </div>
                                                </li>
                                                <li className="list-group-item">
                                                    <div className="row gx-3 gx-lg-4">
                                                        <div className="col">Taxable Product</div>
                                                        <div className="col-auto">
                                                            <div className="form-check form-switch"><input className="form-check-input" type="checkbox" role="switch" id="isearchswitch7" defaultChecked /> <label className="form-check-label" htmlFor="isearchswitch7"></label></div>
                                                        </div>
                                                    </div>
                                                </li>
                                                <li className="list-group-item">
                                                    <div className="row gx-3 gx-lg-4">
                                                        <div className="col">Published Product</div>
                                                        <div className="col-auto">
                                                            <div className="form-check form-switch"><input className="form-check-input" type="checkbox" role="switch" id="isearchswitch8" /> <label className="form-check-label" htmlFor="isearchswitch8"></label></div>
                                                        </div>
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>
                                        <div className="tab-pane fade" id="searchcontacts" role="tabpanel">
                                            <ul className="list-group adminuiux-list-group list-group-flush bg-none show">
                                                <li className="list-group-item">
                                                    <div className="row gx-3 gx-lg-4">
                                                        <div className="col">Have email ID</div>
                                                        <div className="col-auto">
                                                            <div className="form-check form-switch"><input className="form-check-input" type="checkbox" role="switch" id="isearchswitch9" /> <label className="form-check-label" htmlFor="isearchswitch9"></label></div>
                                                        </div>
                                                    </div>
                                                </li>
                                                <li className="list-group-item">
                                                    <div className="row gx-3 gx-lg-4">
                                                        <div className="col">Have phone number</div>
                                                        <div className="col-auto">
                                                            <div className="form-check form-switch"><input className="form-check-input" type="checkbox" role="switch" id="isearchswitch10" defaultChecked /> <label className="form-check-label" htmlFor="isearchswitch10"></label></div>
                                                        </div>
                                                    </div>
                                                </li>
                                                <li className="list-group-item">
                                                    <div className="row gx-3 gx-lg-4">
                                                        <div className="col">Photo available</div>
                                                        <div className="col-auto">
                                                            <div className="form-check form-switch"><input className="form-check-input" type="checkbox" role="switch" id="isearchswitch11" defaultChecked /> <label className="form-check-label" htmlFor="isearchswitch11"></label></div>
                                                        </div>
                                                    </div>
                                                </li>
                                                <li className="list-group-item">
                                                    <div className="row gx-3 gx-lg-4">
                                                        <div className="col">Referral</div>
                                                        <div className="col-auto">
                                                            <div className="form-check form-switch"><input className="form-check-input" type="checkbox" role="switch" id="isearchswitch12" /> <label className="form-check-label" htmlFor="isearchswitch12"></label></div>
                                                        </div>
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div className="p-1">
                                        <div className="row gx-3 gx-lg-4">
                                            <div className="col"><button className="btn btn-link theme-red">Reset</button></div>
                                            <div className="col-auto"><button className="btn btn-theme">Apply</button></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* menu */}
                    <div className="navbar-expand-xl d-none d-xl-block mx-auto">
                        <div className="collapse navbar-collapse" id="mainheaderNavbar">
                            <ul className="navbar-nav">
                                <li className="nav-item dropdown">
                                    <a className="nav-link dropdown-toggle no-caret" data-bs-toggle="dropdown" role="button" aria-expanded="false" data-bs-auto-close="outside">Pages</a>
                                    <div className="dropdown-menu">
                                        <div><Link className="dropdown-item" to="/app/my-profile">Profile</Link></div>
                                        <div className="dropend">
                                            <a className="dropdown-item" data-bs-toggle="dropdown" aria-expanded="false" role="button" data-bs-auto-close="outside">
                                                Company <span className="arrow bi bi-chevron-right"></span>
                                            </a>
                                            <div className="dropdown-menu">
                                                <div><Link className="dropdown-item active" to="/app/company-profile">Company Profile</Link></div>
                                                <div><Link className="dropdown-item" to="/app/dashboard">User Roles </Link></div>
                                                <div><Link className="dropdown-item" to="/app/dashboard">Resources</Link></div>
                                            </div>
                                        </div>
                                        <div><Link className="dropdown-item" to="/app/company-career">Career</Link></div>
                                        <div><Link className="dropdown-item" to="/app/forum">Forum</Link></div>
                                        <div>
                                            <hr className="dropdown-divider" />
                                        </div>
                                        <div><Link className="dropdown-item" to="/app/company-help-center">Help Center</Link></div>
                                        <div><Link className="dropdown-item" to="/auth/onboarding">Onboarding</Link></div>
                                    </div>
                                </li>

                                <li className="nav-item dropdown">
                                    <a className="nav-link dropdown-toggle no-caret" data-bs-toggle="dropdown" role="button" aria-expanded="false">Supportive</a>
                                    <div className="dropdown-menu width-300">
                                        <div className="dropdown-title mb-3 p-2">
                                            <p>Supportive &amp; Helpful Pages</p>
                                            <p className="text-secondary small">Do not make your user lost somewhere else from where they can't come back. Make important journey flawless.</p>
                                        </div>
                                        <div className="row g-0">
                                            <div className="col-12 col-md-12 col-lg-6">
                                                <div><Link className="dropdown-item" to="/auth/login"><i className="bi bi-person me-2 text-theme-1"></i>Sign in</Link></div>
                                                <div><Link className="dropdown-item" to="/auth/signup"><i className="bi bi-person-plus me-2 text-theme-1"></i>Sign up</Link></div>
                                                <div><Link className="dropdown-item" to="/auth/forgot-password"><i className="bi bi-key me-2 text-theme-1"></i>Password</Link></div>
                                                <div><Link className="dropdown-item" to="/extras/maintenance"><i className="bi bi-gear me-2"></i>Maintenance</Link></div>
                                            </div>
                                            <div className="col-12 col-md-12 col-lg-6">
                                                <div><Link className="dropdown-item" to="/extras/404"><i className="bi bi-bug me-2"></i>Error</Link></div>
                                                <div><Link className="dropdown-item" to="/app/company-contact-us"><i className="bi bi-envelope me-2"></i>Contact</Link></div>
                                                <div><Link className="dropdown-item" to="/extras/coming-soon"><i className="bi bi-alarm me-2"></i>Coming Soon</Link></div>
                                            </div>

                                        </div>
                                    </div>
                                </li>
                                <li className='nav-item'><Link className="nav-link" to="/app/company-help-center">Support</Link></li>
                            </ul>
                        </div>
                    </div>

                    {/* right icons button */}
                    <div className="ms-auto ms-lg-0">
                        {/* global search toggle */}
                        <button className="btn btn-link btn-square btn-icon btn-link-header d-lg-none" type="button" onClick={toggleSearch}>
                            <i className="bi bi-search"></i>
                        </button>

                        {/* dark mode */}
                        <button className={`btn btn-link btn-square btnsunmoon btn-link-header ${darkMode ? 'active' : ''}`} id="btn-layout-modes-dark-page" onClick={toggleDarkMode}>
                            <i className="moon mx-auto bi bi-sun"></i>
                            <i className="sun mx-auto bi bi-moon"></i>
                        </button>

                        {/* application list dropdown */}
                        <div className="dropdown d-none d-sm-inline-block">
                            <button className="btn btn-link btn-square btn-icon btn-link-header dropdown-toggle no-caret" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                <i className="bi bi-grid"></i>
                            </button>
                            <div className="dropdown-menu dropdown-menu-end width-300 pt-0 px-0 overflow-hidden">
                                {/* ... dropdown content ... */}
                                <div className="p-3 rounded mb-2">
                                    <h5 className="mb-0">Applications</h5>
                                    <p className="text-secondary small">Make your app innovative</p>
                                </div>
                                <div className="px-2">
                                    <div className="row g-2 text-center mb-2">
                                        <div className="col-4">
                                            <Link className="dropdown-item square-item position-relative" to="/app/finance-dashboard">
                                                <div className="avatar avatar-40 rounded my-2">
                                                    <i className="bi bi-bank fs-5 mx-0"></i>
                                                </div>
                                                <p className="mb-0">Finance</p>
                                                <p className="fs-12 opacity-50 mb-2">Accounting</p>
                                            </Link>
                                        </div>
                                        <div className="col-4">
                                            <Link className="dropdown-item square-item position-relative" to="/app/dashboard">
                                                <div className="avatar avatar-40 rounded my-2">
                                                    <i className="bi bi-globe fs-5 mx-0"></i>
                                                </div>
                                                <p className="mb-0">Network</p>
                                                <p className="fs-12 opacity-50 mb-2">Stabilize</p>
                                            </Link>
                                        </div>
                                        <div className="col-4">
                                            <Link className="dropdown-item square-item position-relative" to="/app/dashboard">
                                                <div className="avatar avatar-40 rounded my-2">
                                                    <i className="bi bi-box fs-5 mx-0"></i>
                                                </div>
                                                <p className="mb-0">Inventory</p>
                                                <p className="fs-12 opacity-50 mb-2">Assuring</p>
                                            </Link>
                                        </div>
                                        <div className="col-4">
                                            <Link className="dropdown-item square-item position-relative" to="/app/dashboard">
                                                <div className="avatar avatar-40 rounded my-2">
                                                    <i className="bi bi-folder fs-5 mx-0"></i>
                                                </div>
                                                <p className="mb-0">Project</p>
                                                <p className="fs-12 opacity-50 mb-2">Management</p>
                                            </Link>
                                        </div>
                                        <div className="col-4">
                                            <Link className="dropdown-item square-item position-relative" to="/app/dashboard">
                                                <div className="avatar avatar-40 rounded my-2">
                                                    <i className="bi bi-people fs-5 mx-0"></i>
                                                </div>
                                                <p className="mb-0">Social</p>
                                                <p className="fs-12 opacity-50 mb-2">Tracking</p>
                                            </Link>
                                        </div>
                                        <div className="col-4">
                                            <Link className="dropdown-item square-item position-relative" to="/app/dashboard">
                                                <div className="avatar avatar-40 rounded my-2">
                                                    <i className="bi bi-journal-bookmark fs-5 mx-0"></i>
                                                </div>
                                                <p className="mb-0">Learning</p>
                                                <p className="fs-12 opacity-50 mb-2">Make-easy</p>
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                                <div className="text-center">
                                    <Link className="btn btn-link text-center" to="/app/dashboard"> View all <i className="bi bi-arrow-right fs-14"></i> </Link>
                                </div>
                            </div>
                        </div>

                        {/* language dropdown */}
                        <div className="dropdown d-none d-sm-inline-block">
                            <button className="btn btn-link btn-square btn-icon btn-link-header dropdown-toggle no-caret" type="button" data-bs-toggle="dropdown" aria-expanded="false"><i className="bi bi-translate"></i></button>
                            <ul className="dropdown-menu dropdown-menu-end">
                                <li><a className="dropdown-item active" data-value="EN">EN - English</a></li>
                                <li><a className="dropdown-item" data-value="FR">FR - French</a></li>
                                <li><a className="dropdown-item" data-value="CH">CH - Chinese</a></li>
                                <li><a className="dropdown-item" data-value="HI">HI - Hindi</a></li>
                            </ul>
                        </div>

                        {/* notification dropdown */}
                        <button className="btn btn-link btn-square btn-icon btn-link-header dropdown-toggle position-relative no-caret" type="button" data-bs-toggle="offcanvas" data-bs-target="#notification" aria-expanded="false">
                            <i className="bi bi-bell"></i>
                            <span className="position-absolute top-0 end-0 badge rounded-pill bg-danger p-1">
                                <small>9+</small>
                                <span className="visually-hidden">unread messages</span>
                            </span>
                        </button>

                        {/* profile dropdown */}
                        <div className="dropdown d-inline-block">
                            <a className="dropdown-toggle btn btn-link btn-square btn-link-header style-none no-caret px-0" id="userprofiledd" data-bs-toggle="dropdown" aria-expanded="false" role="button">
                                <div className="row gx-0 d-inline-flex">
                                    <div className="col-auto align-self-center">
                                        <figure className="avatar avatar-28 rounded-circle coverimg align-middle">
                                            <img src={asset('/assets/img/adminuiux/user-6.jpg')} alt="" id="userphotoonboarding2" />
                                        </figure>
                                    </div>
                                </div>
                            </a>
                            <div className="dropdown-menu dropdown-menu-end width-300 px-0 pt-0" aria-labelledby="userprofiledd">
                                <div className="p-2 rounded">
                                    <Link to="/app/my-profile" className="dropdown-item text-center">
                                        <figure className="avatar avatar-100 rounded-circle coverimg align-middle mb-3">
                                            <img src={asset('/assets/img/adminuiux/user-6.jpg')} alt="" />
                                        </figure>
                                        <h5 className="mb-1">DevUIUX</h5>
                                        <p className="small"><i className="bi bi-trophy me-2"></i> 3 Courses</p>
                                    </Link>
                                </div>
                                <div className="px-2">
                                    <div>
                                        <Link className="dropdown-item" to="/app/dashboard">
                                            <div className="row g-0">
                                                <div className="col align-self-center">
                                                    <i className="avatar avatar-30 rounded-circle me-1 bi bi-speedometer2"></i>
                                                    My Dashboard
                                                </div>
                                                <div className="col-auto avatar-group">
                                                    <figure className="avatar avatar-20 coverimg rounded-circle">
                                                        <img src={asset('/assets/img/adminuiux/user-1.jpg')} alt="" />
                                                    </figure>
                                                    <figure className="avatar avatar-20 coverimg rounded-circle">
                                                        <img src={asset('/assets/img/adminuiux/user-2.jpg')} alt="" />
                                                    </figure>
                                                    <figure className="avatar avatar-20 coverimg rounded-circle">
                                                        <img src={asset('/assets/img/adminuiux/user-4.jpg')} alt="" />
                                                    </figure>
                                                    <div className="avatar avatar-20 bg-theme-1 rounded-circle text-center align-middle">
                                                        <small className="fs-10 align-middle">9+</small>
                                                    </div>
                                                </div>
                                            </div>
                                        </Link>
                                    </div>
                                    <div>
                                        <Link className="dropdown-item" to="/app/earning"><i className="avatar avatar-30 rounded-circle me-1 bi bi-cash-stack"></i> Earning</Link>
                                    </div>
                                    <div>
                                        <Link className="dropdown-item" to="/app/subscription"><i className="avatar avatar-30 rounded-circle me-1 bi bi-gift"></i> Subscription</Link>
                                    </div>
                                    <div>
                                        <Link className="dropdown-item" to="/app/statement"><i className="avatar avatar-30 rounded-circle me-1 bi bi-clipboard-check"></i> Statement</Link>
                                    </div>
                                    <div>
                                        <Link className="dropdown-item" to="/app/account-settings"> <i className="avatar avatar-30 rounded-circle me-1 bi bi-gear"></i> Account Setting </Link>
                                    </div>
                                    <div>
                                        <Link className="dropdown-item theme-red" to="/auth/login"> <i className="avatar avatar-30 rounded-circle me-1 bi bi-power"></i> Logout </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </nav>

            {/* search global wrap */}
            <div className={`adminuiux-search-full ${isSearchActive ? 'active' : ''}`}>
                <div className="row gx-2 align-items-center">
                    <div className="col-auto">
                        {/* close global search toggle */}
                        <button className="btn btn-link btn-square " type="button" onClick={toggleSearch}>
                            <i className="bi bi-arrow-left"></i>
                        </button>
                    </div>
                    <div className="col">
                        <input className="form-control pe-0 border-0" type="search" placeholder="Type something here..." />
                    </div>
                    <div className="col-auto">
                        {/* filter dropdown */}
                        <div className="dropdown input-group-text border-0 p-0">
                            <button className="dropdown-toggle btn btn-link btn-square no-caret" type="button" id="searchfilter2" data-bs-toggle="dropdown" aria-expanded="false">
                                <i className="bi bi-sliders2"></i>
                            </button>
                            <div className="dropdown-menu dropdown-menu-end dropdown-dontclose width-300">
                                {/* ... search filter tabs ... */}
                                <ul className="nav adminuiux-nav" id="searchtab2" role="tablist">
                                    <li className="nav-item" role="presentation">
                                        <button className="nav-link active" id="searchall-tab2" data-bs-toggle="tab" data-bs-target="#searchall2" type="button" role="tab" aria-controls="searchall2" aria-selected="true">All</button>
                                    </li>
                                    {/* ... other tabs ... */}
                                </ul>
                                <div className="tab-content py-3" id="searchtabContent2">
                                    <div className="tab-pane fade active show" id="searchall2" role="tabpanel" aria-labelledby="searchall-tab2">
                                        <ul className="list-group adminuiux-list-group list-group-flush bg-none show">
                                            <li className="list-group-item">
                                                <div className="row gx-3 gx-lg-4">
                                                    <div className="col">Search apps</div>
                                                    <div className="col-auto">
                                                        <div className="form-check form-switch">
                                                            <input className="form-check-input" type="checkbox" role="switch" id="searchswitch1" />
                                                            <label className="form-check-label" htmlFor="searchswitch1"></label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </li>
                                            {/* ... other items ... */}
                                        </ul>
                                    </div>
                                    {/* ... other tab panes ... */}
                                </div>
                                <div className="">
                                    <div className="row gx-3 gx-lg-4">
                                        <div className="col"><button className="btn btn-link">Reset</button></div>
                                        <div className="col-auto">
                                            <button className="btn btn-theme">Apply</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default MainHeader;
